import { ModelActionType, UserGrantType, ZitadelRoles } from "../enums";

interface MembershipList {
  roles: string[];
}

interface Membership {
  result?: MembershipList[];
}

export const checkIsCustomerAdmin = (data: Membership | undefined) =>
  Boolean(data && data.result && data.result[0]?.roles?.includes(ZitadelRoles.ADMIN));

const permissionLabels: Record<string, string> = {
  [UserGrantType.viewer]: "Can view",
  [UserGrantType.editor]: "Can edit",
  [UserGrantType.administrator]: "Admin",
};

export const accessOptions = Object.values(UserGrantType)
  .filter((item) => item !== "owner")
  .filter((item) => item !== "upstreamremoteowner")
  .map((item) => ({
    label: permissionLabels[item] || item,
    value: item,
  }));

export const getCanUserArchive = (permission: UserGrantType | undefined) => permission === UserGrantType.owner; // only file owner can remove the file

export const getCanUserExtract = (permission: UserGrantType | undefined) => permission === UserGrantType.owner; // only model owner can extract the model

export const getCanUserEdit = (permission: UserGrantType | undefined) =>
  permission === UserGrantType.editor ||
  permission === UserGrantType.administrator ||
  permission === UserGrantType.owner;

export const getCanUserEditControlTags = (permission: UserGrantType | undefined) =>
  permission === UserGrantType.administrator || permission === UserGrantType.owner;

export const getCanUserEditObjectInfosecLevel = (permission: UserGrantType | undefined) =>
  permission === UserGrantType.administrator || permission === UserGrantType.owner;

export const getCanUserShare = (permission: UserGrantType | undefined) =>
  permission === UserGrantType.editor ||
  permission === UserGrantType.upstreamRemoteOwner ||
  permission === UserGrantType.administrator ||
  permission === UserGrantType.owner;

export const getCanUserViewOnly = (permission: UserGrantType | undefined) => permission === UserGrantType.viewer; // permission === UserGrantType.approver

export const getCanUser = (permission: UserGrantType | undefined) => ({
  [ModelActionType.EXTRACT]: getCanUserExtract(permission),
  [ModelActionType.ARCHIVE]: getCanUserArchive(permission),
  [ModelActionType.RENAME]: getCanUserEdit(permission),
  [ModelActionType.SHARE]: getCanUserShare(permission),
});
